import { render, staticRenderFns } from "./PostProcessDialog.vue?vue&type=template&id=509b9b57&scoped=true"
import script from "./PostProcessDialog.vue?vue&type=script&lang=js"
export * from "./PostProcessDialog.vue?vue&type=script&lang=js"
import style0 from "./PostProcessDialog.vue?vue&type=style&index=0&id=509b9b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b9b57",
  null
  
)

export default component.exports